import "./Spinner.css"
import React from "react";

const Spinner=()=>{
    return(
        <div>
            <div className="spineer"></div>
        </div>
    )
}
export default Spinner;